module.exports = __webpack_public_path__ + "static/media/telegram_orange_white.69841609.svg";